// extracted by mini-css-extract-plugin
export default {"wrapper":"BarsChartWithLegend_wrapper__hkMk1","tooltip__body":"BarsChartWithLegend_tooltip__body__-erbK","chart__legend__value":"BarsChartWithLegend_chart__legend__value__Epmon"};